import React from "react";
import { ITEM_TYPE } from "../../Enums/Enum";
import TwoItemSummaryFooter from "../shared/TwoItemSummaryFooter";

/**
 * Footer for the EE & ER Taxes table showing totals.
 */
const TaxTableFooter = React.memo(function TaxTableFooter({ eeAndErTaxes, formatCurrency }) {
    const totalEETaxes = (eeAndErTaxes || []).reduce(
        (sum, r) => sum + (Number(r.taxType) === Number(ITEM_TYPE.EmployeeTaxes) ? Number(r.amount || 0) : 0), 0
    );
    const totalERTaxes = (eeAndErTaxes || []).reduce(
        (sum, r) => sum + (Number(r.taxType) === Number(ITEM_TYPE.EmployerTaxes) ? Number(r.amount || 0) : 0), 0
    );

    return (
        <TwoItemSummaryFooter
            items={[
                { label: "Total EE Taxes", value: formatCurrency(totalEETaxes) },
                { label: "Total ER Taxes", value: formatCurrency(totalERTaxes) }
            ]}
        />
    );
});

export default TaxTableFooter;
